import { Paper } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { DataGridNoRows } from 'components/general/table/dataGrid/DataGridNoRows'
import { useTranslation } from 'react-i18next'
import { useGetAllRatesQuery } from 'redux/apis/interest-rates-api'
import { InterestPeriod } from 'types/interest-periods/interest-period'
import { formatDate } from 'utils/date-utils'

export const InterestRatePeriodsTable = () => {
    const { t } = useTranslation()
    const { data: periods, isLoading } = useGetAllRatesQuery()

    const columns: GridColDef<InterestPeriod>[] = [
        {
            field: 'startDate',
            headerName: t('TEXT_DATE_FROM'),
            flex: 1,
            editable: false,
            sortable: false,
            minWidth: 200,
            valueGetter: (params) => formatDate(params.row.startDate),
        },
        {
            field: 'endDate',
            headerName: t('TEXT_DATE_TO'),
            flex: 1,
            editable: false,
            sortable: false,
            minWidth: 200,
            valueGetter: (params) => formatDate(params.row.endDate),
        },
        {
            field: 'annualInterestRate',
            headerName: t('TEXT_INTEREST_RATE_LABEL'),
            flex: 1,
            editable: false,
            minWidth: 200,
            maxWidth: 220,
            valueGetter: (params) => Intl.NumberFormat('no-NO').format(params.row.annualInterestRate * 100),
        },
    ]

    return (
        <Paper elevation={0}>
            <DataGrid
                rows={periods || []}
                density="comfortable"
                rowCount={periods?.length || 0}
                columns={columns}
                autoHeight
                disableRowSelectionOnClick
                disableColumnMenu
                hideFooterSelectedRowCount
                hideFooter
                hideFooterPagination
                slots={{
                    noRowsOverlay: DataGridNoRows,
                }}
                loading={isLoading}
                keepNonExistentRowsSelected
            />
        </Paper>
    )
}
